// extracted by mini-css-extract-plugin
export var card = "_vq-0";